<template>
  <div class="form-wrapper grid gap-5 mb-5 grid-cols-4-default md:grid-cols-6-default">
    <!-- First Name -->
    <div class="col-span-6 md:col-span-2">
      <label class="font-body text-base text-gray-900  " :for="getValidationName('first_name')"
        >{{ translations.text.first_name }}<span class="text-orange ml-1">*</span></label
      >
      <div class="my-2">
        <input
          v-validate.persist="'required|alpha_spaces|min:3|max:255'"
          :class="{
            'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has(getValidationName('first_name')),
          }"
          :name="getValidationName('first_name')"
          type="text"
          :data-vv-as="translations.text.first_name"
          :placeholder="translations.text.first_name"
          v-model="data.first_name"
          @change="validateValues(getValidationName('first_name'))"
          class="text-gray-900 text-base font-semibold"
          :key="getValidationName('first_name')"
        />
        <span v-show="errors.first(getValidationName('first_name'))" class="font-body text-xs text-orange font-semibold">{{ errors.first(getValidationName('first_name')) }}</span>
      </div>
    </div>
    <!-- Middle Name -->
    <div class="col-span-6 md:col-span-2">
      <label class="font-body text-base text-gray-900  " :for="getValidationName('middle_name')">{{ translations.text.middle_name }}</label>
      <div class="my-2">
        <input
          v-validate.persist="'alpha_spaces|min:3|max:255'"
          :class="{
            'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has(getValidationName('middle_name')),
          }"
          :name="getValidationName('middle_name')"
          type="text"
          :data-vv-as="translations.text.middle_name"
          :placeholder="translations.text.middle_name"
          v-model="data.middle_name"
          @change="validateValues(getValidationName('middle_name'))"
          class="text-gray-900 text-base font-semibold"
          :key="getValidationName('middle_name')"
        />
        <span v-show="errors.first(getValidationName('middle_name'))" class="font-body text-xs text-orange font-semibold">{{ errors.first(getValidationName('middle_name')) }}</span>
      </div>
    </div>
    <!-- Last Name -->
    <div class="col-span-6 md:col-span-2">
      <label class="font-body text-base text-gray-900  " :for="getValidationName('last_name')"
        >{{ translations.text.last_name }}<span class="text-orange ml-1">*</span></label
      >
      <div class="my-2">
        <input
          v-validate.persist="'required|alpha_spaces|max:255'"
          :class="{ 'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has(getValidationName('last_name')) }"
          :name="getValidationName('last_name')"
          type="text"
          :data-vv-as="translations.text.last_name"
          :placeholder="translations.text.last_name"
          v-model="data.last_name"
          @change="validateValues(getValidationName('last_name'))"
          class="text-gray-900 text-base font-semibold"
          :key="getValidationName('last_name')"
        />
        <span v-show="errors.has(getValidationName('last_name'))" class="font-body text-xs text-orange font-semibold">{{ errors.first(getValidationName('last_name')) }}</span>
      </div>
    </div>
    <!-- Date of Birth -->
    <div class="col-span-6 lg:col-span-6 grid grid-cols-6-default gap-5">
      <!-- Year of Birth -->
      <div class="col-span-2 md:col-span-2">
        <!-- <label class="label is-small" :for="getValidationName('dob_year')">{{ translations.text.year }}<span class="text-orange ml-1">*</span></label>
        <div class="my-2">
          <span class="select is-fullwidth">
            <select
              v-validate.persist="{ required: true, 'is-over-18': formattedDateOfBirth }"
              :class="{
                'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has(getValidationName('dob_year')),
              }"
              :data-vv-as="translations.text.year"
              :name="getValidationName('dob_year')"
              v-model="data.dateofbirth.year"
              class="text-base text-gray-900 font-semibold rtl:bg-left"
              :key="getValidationName('dob_year')"
              @change="validateValues(getValidationName('dob_year'))"
              @blur="validateValues(getValidationName('dob_year'))"
            >
              <option value="" selected hidden>{{ translations.text.year }}</option>
              <option v-for="year in years" :value="year" :key="year">{{ year }}</option>
            </select>
          </span>
          <span v-show="errors.has(getValidationName('dob_year'))" class="font-body text-xs text-orange font-semibold">{{ errors.first(getValidationName('dob_year')) }}</span>
        </div> -->
        <Select
          :key="getValidationName('dob_year')"
          v-model="data.dateofbirth.year"
          :name="getValidationName('dob_year')"
          :rules="{
            required: true,
            'is-over-18': data.dateofbirth.day + '-' + data.dateofbirth.month + '-' + data.dateofbirth.year,
          }"
          :placeholder="translations.text.year"
          :options="years"
          :label="translations.text.year"
          @change="validateValues(getValidationName('dob_year'))"
          @blur="validateValues(getValidationName('dob_year'))"
        />
      </div>
      <!-- Month of Birth -->
      <div class="col-span-2 md:col-span-2">
        <!-- <label class="label is-small" :for="getValidationName('dob_month')">{{ translations.text.month }}<span class="text-orange ml-1">*</span></label>
        <div class="my-2">
          <span class="select is-fullwidth">
            <select
              v-validate.persist="{ required: true, 'is-over-18': formattedDateOfBirth }"
              :class="{
                'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has(getValidationName('dob_month')),
              }"
              :data-vv-as="translations.text.month"
              :name="getValidationName('dob_month')"
              v-model="data.dateofbirth.month"
              @change="validateValues(getValidationName('dob_month'))"
              @blur="validateValues(getValidationName('dob_month'))"
              class="text-base text-gray-900 font-semibold rtl:bg-left"
              :key="getValidationName('dob_month')"
            >
              <option value="" selected hidden>{{ translations.text.month }}</option>
              <option v-for="(month, activeIndex) in translations.months" :value="activeIndex" :key="activeIndex">{{ month }}</option>
            </select>
          </span>
          <span v-show="errors.has(getValidationName('dob_month'))" class="font-body text-xs text-orange font-semibold" :class="{ 'has-text-right': Language == 'fa' }">{{
            errors.first(getValidationName('dob_month'))
          }}</span>
        </div> -->
        <Select
          :key="getValidationName('dob_month')"
          v-model="data.dateofbirth.month"
          :name="getValidationName('dob_month')"
          :rules="{
            required: true,
          }"
          :placeholder="translations.text.month"
          :options="translations.months"
          :label="translations.text.month"
          @change="validateValues(getValidationName('dob_month'))"
          @blur="validateValues(getValidationName('dob_month'))"
        />
      </div>
      <!-- Day of Birth -->
      <div class="col-span-2 md:col-span-2">
        <!-- <label class="label is-small" :for="getValidationName('dob_day')">{{ translations.text.day }}<span class="text-orange ml-1">*</span></label>
        <div class="my-2">
          <span class="select is-fullwidth">
            <select
              v-validate.persist="{ required: true, 'is-over-18': formattedDateOfBirth }"
              :class="{
                'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has(getValidationName('dob_day')),
              }"
              :data-vv-as="translations.text.day"
              :name="getValidationName('dob_day')"
              v-model="data.dateofbirth.day"
              @change="validateValues(getValidationName('dob_day'))"
              @blur="validateValues(getValidationName('dob_day'))"
              class="text-base text-gray-900 font-semibold rtl:bg-left"
            >
              <option value="" selected hidden>{{ translations.text.day }}</option>
              <option v-for="day in daysInMonth" :value="day" :key="day">{{ day }}</option>
            </select>
          </span>
          <span v-show="errors.has(getValidationName('dob_day'))" class="font-body text-xs text-orange font-semibold">{{ errors.first(getValidationName('dob_day')) }}</span>
        </div> -->
        <Select
          :key="getValidationName('dob_day')"
          v-model="data.dateofbirth.day"
          :name="getValidationName('dob_day')"
          :rules="{
            required: true,
          }"
          :placeholder="translations.text.day"
          :options="daysInMonth"
          :label="translations.text.day"
          @change="validateValues(getValidationName('dob_day'))"
          @blur="validateValues(getValidationName('dob_day'))"
        />
      </div>
    </div>
    <!-- Address -->
    <div class="col-span-6 md:col-span-6">
      <label class="font-body text-base text-gray-900  " :for="getValidationName('address')"
        >{{ translations.text.address }} 1<span class="text-orange ml-1">*</span></label
      >
      <div class="my-2">
        <input
          v-validate.persist="'required|min:3|max:255'"
          :class="{ 'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has(getValidationName('address')) }"
          :name="getValidationName('address')"
          type="text"
          :data-vv-as="translations.text.address"
          :placeholder="translations.text.address_placeholder"
          v-model="data.address"
          @change="validateValues(getValidationName('address'))"
          class="text-gray-900 text-base font-semibold"
        />
        <span v-show="errors.has(getValidationName('address'))" class="font-body text-xs text-orange font-semibold">{{ errors.first(getValidationName('address')) }}</span>
      </div>
    </div>
    <!-- Region -->
    <div class="col-span-6 md:col-span-6" v-if="accountType.toLowerCase() === 'partner'">
      <label class="font-body text-base text-gray-900  " :for="getValidationName('ib_main_target_region')"
        >{{ translations.text.target_geo_location }}<span class="text-orange ml-1">*</span></label
      >
      <div class="my-2">
        <input
          v-validate.persist="'required|alpha_spaces|min:3|max:50'"
          :class="{
            'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has(getValidationName('ib_main_target_region')),
          }"
          :name="getValidationName('ib_main_target_region')"
          type="text"
          :data-vv-as="translations.text.target_geo_location"
          :placeholder="translations.text.target_geo_location"
          v-model="data.ib_main_target_region"
          @change="validateValues(getValidationName('ib_main_target_region'))"
          class="text-gray-900 text-base font-semibold"
        />
        <span v-show="errors.has(getValidationName('ib_main_target_region'))" class="font-body text-xs text-orange font-semibold">{{
          errors.first(getValidationName('ib_main_target_region'))
        }}</span>
      </div>
    </div>
    <!-- Address 2 -->
    <div class="col-span-6 md:col-span-6">
      <label class="font-body text-base text-gray-900  " :for="getValidationName('address2')">{{ translations.text.address2 }}</label>
      <div class="my-2">
        <input
          v-validate.persist="'min:3|max:255'"
          :class="{ 'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has(getValidationName('address2')) }"
          :name="getValidationName('address2')"
          type="text"
          :data-vv-as="translations.text.address2"
          :placeholder="translations.text.optional"
          v-model="data.address2"
          @change="validateValues(getValidationName('address2'))"
          class="text-gray-900 text-base font-semibold"
        />
        <span v-show="errors.has(getValidationName('address2'))" class="font-body text-xs text-orange font-semibold">{{ errors.first(getValidationName('address2')) }}</span>
      </div>
    </div>
    <!-- Town/City, Province/State, Postal/Zip Code -->
    <div class="col-span-6 lg:col-span-6 grid grid-cols-6-default gap-5">
      <!-- Town/City -->
      <div class="col-span-6 md:col-span-2">
        <label class="font-body text-base text-gray-900  " :for="getValidationName('city')">{{ translations.text.city }}<span class="text-orange ml-1">*</span></label>
        <div class="my-2">
          <input
            v-validate.persist="'required|min:3|max:255'"
            :class="{ 'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has(getValidationName('city')) }"
            :name="getValidationName('city')"
            type="text"
            :data-vv-as="translations.text.city"
            :placeholder="translations.text.city"
            v-model="data.city"
            @change="validateValues(getValidationName('city'))"
            class="text-base text-gray-900 font-semibold"
          />
          <span v-show="errors.has(getValidationName('city'))" class="font-body text-xs text-orange font-semibold">{{ errors.first(getValidationName('city')) }}</span>
        </div>
      </div>
      <!-- Province/State -->
      <div class="col-span-6 md:col-span-2">
        <label class="font-body text-base text-gray-900  " :for="getValidationName('state_province')"
          >{{ translations.text.state_province }}<span class="text-orange ml-1">*</span></label
        >
        <div class="my-2">
          <input
            v-validate.persist="'required|min:3|max:255'"
            :class="{
              'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has(getValidationName('state_province')),
            }"
            :name="getValidationName('state_province')"
            type="text"
            :data-vv-as="translations.text.state_province"
            :placeholder="translations.text.state_province"
            v-model="data.state_province"
            @change="validateValues(getValidationName('state_province'))"
            class="text-base text-gray-900 font-semibold"
          />
          <span v-show="errors.has(getValidationName('state_province'))" class="font-body text-xs text-orange font-semibold">{{
            errors.first(getValidationName('state_province'))
          }}</span>
        </div>
      </div>
      <!-- Postal/Zip Code -->
      <div class="col-span-6 md:col-span-2">
        <label class="font-body text-base text-gray-900  " :for="getValidationName('post_code')"
          >{{ translations.text.post_zip_code }}<span class="text-orange ml-1">*</span></label
        >
        <div class="my-2">
          <input
            v-validate.persist="'required|max:255'"
            :class="{
              'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has(getValidationName('post_code')),
            }"
            :name="getValidationName('post_code')"
            type="text"
            :data-vv-as="translations.text.post_code"
            :placeholder="translations.text.post_zip_code"
            v-model="data.post_code"
            @change="validateValues(getValidationName('post_code'))"
            class="text-base text-gray-900 font-semibold"
          />
          <span v-show="errors.has(getValidationName('post_code'))" class="font-body text-xs text-orange font-semibold">{{ errors.first(getValidationName('post_code')) }}</span>
        </div>
      </div>
    </div>

    <!-- Social media -->
    <div class="col-span-6 md:col-span-3">
      <label class="font-body text-base text-gray-900  " :for="getValidationName('social_media')">{{ translations.text.social_media.tTitle() }}</label>
      <div class="my-2">
        <input
          v-validate.persist="'max:255'"
          :class="{ 'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has(getValidationName('social_media')) }"
          :name="getValidationName('social_media')"
          type="text"
          :data-vv-as="translations.text.social_media"
          :placeholder="translations.text.social_media"
          v-model="data.social_media"
          @change="validateValues(getValidationName('social_media'))"
          class="text-gray-900 text-base font-semibold"
        />
        <span v-show="errors.has(getValidationName('social_media'))" class="font-body text-xs text-orange font-semibold">{{
          errors.first(getValidationName('social_media'))
        }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import Select from '../reusableComponents/Select.vue'

export default {
  components: { Select },

  props: {
    accountType: String,
    index: Number,
    translations: Object,
    dataArray: Array,
    type: String,
    prefilledTestData: Boolean,
    testData: Object,
    isContinuePressedWithErrors: Boolean,
  },
  emits: ['populate-validation-errors', 'ChangeShareholderData', 'ChangeDirectorData'],
  data() {
    return {
      years: Array.from({ length: 100 }, (v, i) => moment().year() - i + 1),
      data: {
        first_name: '',
        middle_name: '',
        last_name: '',
        dateofbirth: {
          day: '',
          month: '',
          year: '',
        },
        address: '',
        address2: '',
        ib_main_target_region: '',
        city: '',
        state_province: '',
        post_code: '',
        social_media: '',
      },
    }
  },
  created() {
    this.prefillData()
  },
  mounted() {
    this.$nextTick(() => {
      // Emit valid data if no required fields are empty and no invalid fields
      if (!this.checkRequiredFields && !this.hasAnyInvalidFields) {
        this.emitValidData()
      } else {
        this.emitInvalidData()
      }
    })
  },

  computed: {
    ...mapGetters({
      Language: 'language/code',
    }),

    daysInMonth() {
      const year = this.data.dateofbirth.year || new Date().getFullYear()
      const month = this.data.dateofbirth.month || new Date().getMonth() + 1
      return Array.from({ length: new Date(year, month, 0).getDate() }, (_, i) => i + 1)
    },
    // formattedDateOfBirth() {
    //   /*
    //   Extract day, month, and year from the dateofbirth object.
    //   If any part of the date is missing or not a number, default to 0.
    //   Then return the formatted date in the format "day-month-year".
    // */
    //   const day = Number(this.data?.dateofbirth?.day) || 0
    //   const month = Number(this.data?.dateofbirth?.month) || 0
    //   const year = Number(this.data?.dateofbirth?.year) || 0

    //   // Return formatted date
    //   return `${day}-${month}-${year}`
    // },
    hasAnyInvalidFields() {
      return Object.keys(this.$validator.flags).some(field => this.$validator.flags[field].valid === false)
    },
    checkRequiredFields() {
      // Filter to get the fields with the 'required' rule
      const requiredFields = this.$validator.fields.items.filter(field => field.isRequired)

      // Check if any required field is empty
      const hasEmptyField = requiredFields.some(field => {
        return !field.value || field.value === '' // Check if the field is empty
      })

      return hasEmptyField // Return true if any required field is empty, false otherwise
    },
  },
  watch: {
    // watcher for the i18n language change
    '$i18n.locale'() {
      this.$validator.reset()
    },
    isContinuePressedWithErrors() {
      // is used to revalidate the forms when user click continue and is with errors in parent
      this.validateValues()
    },
  },
  methods: {
    // given the field unique names by type and index
    getValidationName(field) {
      return this.type === 'Shareholder' ? `sh-${field}-${this.index}` : `dir-${field}-${this.index}`
    },

    emitValidData() {
      const eventType = this.type === 'Shareholder' ? 'ChangeShareholderData' : 'ChangeDirectorData'
      // Emit the data and indicate it is valid
      this.$emit(eventType, { index: this.index, data: this.data, isValid: true, invalidIndex: this.index })
    },

    emitInvalidData() {
      const eventType = this.type === 'Shareholder' ? 'ChangeShareholderData' : 'ChangeDirectorData'
      // Emit an invalid state
      this.$emit(eventType, { invalidIndex: this.index, isValid: false })
    },

    prefillData() {
      // Prefill data based on test data and type
      let dataToPrefill

      // Check if testData is provided and prefilledTestData flag is true
      if (this.prefilledTestData && this.testData) {
        // make a clone object of this.testData in order to prevent it from updates coming from the child component
        const clonedTestData = JSON.parse(JSON.stringify(this.testData))
        dataToPrefill = this.type === 'Shareholder' ? clonedTestData.shareholders[this.index - 1] : clonedTestData.directors[this.index - 1]

        // Assign the test data if it exists
        if (dataToPrefill && Object.keys(dataToPrefill).length !== 0) {
          this.data = dataToPrefill
          return
        }
      }

      // If testData is not provided or not prefilled, use the existing data from dataArray
      const existingDataToPrefill = this.dataArray[this.index - 1]

      if (existingDataToPrefill && Object.keys(existingDataToPrefill).length !== 0) {
        this.data = existingDataToPrefill
        return
      }
    },

    validateValues(field) {
      this.$validator.validate(field).then(isValid => {
        if (!isValid) {
          //  Emit the invalid state
          this.emitInvalidData()
        } else {
          // Check if any field is invalid before emitting data
          if (!this.hasAnyInvalidFields) {
            // Emit data if no invalid fields exist
            this.emitValidData()
          } else {
            //  Emit the invalid state
            this.emitInvalidData()
          }
        }
      })
    },
  },
}
</script>
